(function () {
  "use strict";

  // ============================================
  // PAGE-LEVEL ELEMENTS
  // ============================================
  var heroSection = document.querySelector(".sudoku-hero");
  var introSection = document.getElementById("sudokuIntro");
  var boardSection = document.getElementById("sudokuPlay");
  var endSection = document.getElementById("sudokuEnd");
  var startBtn = document.getElementById("sudokuStartBtn");
  var playAgainBtn = document.getElementById("sudokuPlayAgain");
  var finalTimeEl = document.getElementById("sudokuFinalTime");

  // Bail out if we're not on the sudoku page
  if (!boardSection) return;

  // ============================================
  // GAME ELEMENTS (inside boardSection)
  // ============================================
  var levelScreen = document.getElementById("sudokuLevelScreen");
  var gameScreen = document.getElementById("sudokuGameScreen");
  var boardEl = document.getElementById("sudokuBoard");
  var timerEl = document.getElementById("sudokuTimer");
  var levelBadge = document.getElementById("sudokuLevelBadge");
  var numberPadEl = document.getElementById("sudokuNumberPad");

  // ============================================
  // PAGE SECTION TRANSITIONS
  // ============================================
  function showSection(el) {
    if (!el) return;
    el.style.display = "";
    // Force reflow so transition fires
    void el.offsetHeight;
    el.classList.add("sudoku-section--active");
  }

  var TRANSITION_MS = 400;

  function hideSection(el, callback) {
    if (!el) { if (callback) callback(); return; }
    el.classList.remove("sudoku-section--active");
    setTimeout(function () {
      el.style.display = "none";
      if (callback) callback();
    }, TRANSITION_MS);
  }

  // ============================================
  // GAME CONFIG
  // ============================================
  var LEVEL_CONFIG = {
    easy: { size: 4, boxRows: 2, boxCols: 2, cluesMin: 8, cluesMax: 10, checkBox: false },
    medium: { size: 6, boxRows: 2, boxCols: 3, cluesMin: 18, cluesMax: 22, checkBox: true },
    hard: { size: 9, boxRows: 3, boxCols: 3, cluesMin: 25, cluesMax: 28, checkBox: true }
  };

  var LEVEL_LABELS = { easy: "Easy (4×4)", medium: "Medium (6×6)", hard: "Hard (9×9)" };

  var state = {
    level: "easy",
    size: 4,
    boxRows: 2,
    boxCols: 2,
    checkBox: false,
    solution: null,
    puzzle: null,
    given: null,
    selectedCell: null,
    startTime: null,
    timerId: null,
    cells: []
  };

  // ============================================
  // GRID HELPERS
  // ============================================
  function createEmptyGrid(size) {
    return Array.from({ length: size }, function () { return Array(size).fill(0); });
  }

  function isValid(grid, row, col, num, size, boxRows, boxCols, checkBox) {
    var c, r, br, bc;
    for (c = 0; c < size; c++) if (grid[row][c] === num) return false;
    for (r = 0; r < size; r++) if (grid[r][col] === num) return false;
    if (checkBox && boxRows > 0 && boxCols > 0) {
      br = Math.floor(row / boxRows) * boxRows;
      bc = Math.floor(col / boxCols) * boxCols;
      for (r = br; r < br + boxRows; r++)
        for (c = bc; c < bc + boxCols; c++)
          if (grid[r][c] === num) return false;
    }
    return true;
  }

  function solve(grid, size, boxRows, boxCols, checkBox) {
    var maxNum = size;
    var nums = Array.from({ length: maxNum }, function (_, i) { return i + 1; }).sort(function () { return Math.random() - 0.5; });
    var r, c, idx;
    for (r = 0; r < size; r++) {
      for (c = 0; c < size; c++) {
        if (grid[r][c] !== 0) continue;
        for (idx = 0; idx < nums.length; idx++) {
          if (!isValid(grid, r, c, nums[idx], size, boxRows, boxCols, checkBox)) continue;
          grid[r][c] = nums[idx];
          if (solve(grid, size, boxRows, boxCols, checkBox)) return true;
          grid[r][c] = 0;
        }
        return false;
      }
    }
    return true;
  }

  function generateFullGrid(size, boxRows, boxCols, checkBox) {
    var grid = createEmptyGrid(size);
    solve(grid, size, boxRows, boxCols, checkBox);
    return grid;
  }

  function getShuffledIndices(size) {
    var indices = [];
    var r, c, i, j, tmp;
    for (r = 0; r < size; r++)
      for (c = 0; c < size; c++) indices.push({ r: r, c: c });
    for (i = indices.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      tmp = indices[i];
      indices[i] = indices[j];
      indices[j] = tmp;
    }
    return indices;
  }

  function createPuzzle(level) {
    var config = LEVEL_CONFIG[level];
    var size = config.size;
    var solution = generateFullGrid(size, config.boxRows, config.boxCols, config.checkBox);
    var cluesCount = config.cluesMin + Math.floor(Math.random() * (config.cluesMax - config.cluesMin + 1));
    var total = size * size;
    var toRemove = total - cluesCount;
    var puzzle = solution.map(function (row) { return row.slice(); });
    var given = puzzle.map(function (row) { return row.map(function () { return false; }); });
    var indices = getShuffledIndices(size);
    var k, r, c;
    for (k = 0; k < toRemove; k++) {
      puzzle[indices[k].r][indices[k].c] = null;
    }
    for (r = 0; r < size; r++)
      for (c = 0; c < size; c++)
        if (puzzle[r][c] !== null) given[r][c] = true;
    return { solution: solution, puzzle: puzzle, given: given };
  }

  // ============================================
  // BOARD RENDERING
  // ============================================
  function flatIndex(r, c) {
    return r * state.size + c;
  }

  function updateCellUI(index, value, isError, isSameNumber) {
    var cell = state.cells[index];
    if (!cell) return;
    var r = Math.floor(index / state.size);
    var c = index % state.size;
    var isGiven = state.given[r][c];
    cell.textContent = (value !== null && value !== "") ? value : "";
    cell.classList.remove("sudoku-cell--user", "sudoku-cell--given", "sudoku-cell--error", "sudoku-cell--same");
    if (isGiven) cell.classList.add("sudoku-cell--given");
    else cell.classList.add("sudoku-cell--user");
    if (isError) cell.classList.add("sudoku-cell--error");
    if (isSameNumber) cell.classList.add("sudoku-cell--same");
  }

  function getCurrentGrid() {
    var grid = state.puzzle.map(function (row) { return row.slice(); });
    var total = state.size * state.size;
    var i, r, c, val;
    for (i = 0; i < total; i++) {
      r = Math.floor(i / state.size);
      c = i % state.size;
      if (state.given[r][c]) continue;
      val = state.cells[i] && state.cells[i].textContent.trim();
      grid[r][c] = val === "" ? null : parseInt(val, 10);
    }
    return grid;
  }

  function getConflicts(grid, row, col) {
    var num = grid[row][col];
    var maxNum = state.size;
    if (num == null || isNaN(num) || num < 1 || num > maxNum) return { error: false, same: [] };
    var same = [];
    var c, r, br, bc;
    for (c = 0; c < state.size; c++) {
      if (c !== col && grid[row][c] === num) same.push(flatIndex(row, c));
    }
    for (r = 0; r < state.size; r++) {
      if (r !== row && grid[r][col] === num) same.push(flatIndex(r, col));
    }
    if (state.checkBox && state.boxRows > 0 && state.boxCols > 0) {
      br = Math.floor(row / state.boxRows) * state.boxRows;
      bc = Math.floor(col / state.boxCols) * state.boxCols;
      for (r = br; r < br + state.boxRows; r++) {
        for (c = bc; c < bc + state.boxCols; c++) {
          if ((r !== row || c !== col) && grid[r][c] === num)
            same.push(flatIndex(r, c));
        }
      }
    }
    return { error: same.length > 0, same: same };
  }

  function refreshBoardHighlights() {
    var grid = getCurrentGrid();
    var total = state.size * state.size;
    var i, r, c, result, val;
    for (i = 0; i < total; i++) {
      r = Math.floor(i / state.size);
      c = i % state.size;
      result = getConflicts(grid, r, c);
      val = grid[r][c];
      updateCellUI(i, val !== null ? String(val) : "", result.error, result.same.length > 0);
    }
  }

  function isComplete() {
    var grid = getCurrentGrid();
    var r, c, result;
    for (r = 0; r < state.size; r++) {
      for (c = 0; c < state.size; c++) {
        if (grid[r][c] == null) return false;
        result = getConflicts(grid, r, c);
        if (result.error) return false;
      }
    }
    return true;
  }

  function checkWin() {
    if (!isComplete()) return;
    stopTimer();
    // Update end-screen time
    if (finalTimeEl) finalTimeEl.textContent = timerEl.textContent;
    // Transition: hide board, then show end
    hideSection(boardSection, function () {
      showSection(endSection);
    });
  }

  function buildBoard() {
    var size = state.size;
    var boxRows = state.boxRows;
    var boxCols = state.boxCols;
    var r, c, cell, edgeRight, edgeBottom, val;
    boardEl.innerHTML = "";
    boardEl.className = "sudoku-board sudoku-board--" + size;
    boardEl.style.gridTemplateColumns = "repeat(" + size + ", 1fr)";
    boardEl.style.gridTemplateRows = "repeat(" + size + ", 1fr)";
    state.cells = [];
    for (r = 0; r < size; r++) {
      for (c = 0; c < size; c++) {
        cell = document.createElement("div");
        cell.className = "sudoku-cell";
        edgeRight = (c + 1) % boxCols === 0;
        edgeBottom = (r + 1) % boxRows === 0;
        if (edgeRight) cell.classList.add("sudoku-cell--edge-r");
        if (edgeBottom) cell.classList.add("sudoku-cell--edge-b");
        cell.dataset.r = r;
        cell.dataset.c = c;
        val = state.puzzle[r][c];
        if (state.given[r][c]) {
          cell.textContent = val;
          cell.classList.add("sudoku-cell--given");
        } else {
          cell.classList.add("sudoku-cell--user");
        }
        cell.addEventListener("click", (function (row, col) {
          return function () { selectCell(row, col); };
        })(r, c));
        boardEl.appendChild(cell);
        state.cells.push(cell);
      }
    }
  }

  function updateNumberPad() {
    var size = state.size;
    var buttons = numberPadEl.querySelectorAll(".sudoku-num-btn[data-num]");
    buttons.forEach(function (btn) {
      var num = parseInt(btn.dataset.num, 10);
      if (num === 0) {
        btn.style.display = "";
        return;
      }
      btn.style.display = num <= size ? "" : "none";
    });
    numberPadEl.style.gridTemplateColumns = size <= 4 ? "repeat(3, 1fr)" : "repeat(5, 1fr)";
  }

  // ============================================
  // CELL INTERACTION
  // ============================================
  function selectCell(r, c) {
    if (state.given[r][c]) return;
    state.cells.forEach(function (cell) { cell.classList.remove("sudoku-cell--selected"); });
    state.selectedCell = { r: r, c: c };
    state.cells[flatIndex(r, c)].classList.add("sudoku-cell--selected");
  }

  function findNextSelectableCell(r, c, direction) {
    var size = state.size;
    var nr, nc;
    if (direction === "up") {
      for (nr = r - 1; nr >= 0; nr--) if (!state.given[nr][c]) return { r: nr, c: c };
    } else if (direction === "down") {
      for (nr = r + 1; nr < size; nr++) if (!state.given[nr][c]) return { r: nr, c: c };
    } else if (direction === "left") {
      for (nc = c - 1; nc >= 0; nc--) if (!state.given[r][nc]) return { r: r, c: nc };
    } else if (direction === "right") {
      for (nc = c + 1; nc < size; nc++) if (!state.given[r][nc]) return { r: r, c: nc };
    }
    return null;
  }

  function setCellValue(r, c, num) {
    if (state.given[r][c]) return;
    var maxNum = state.size;
    if (num !== 0 && (num < 1 || num > maxNum)) return;
    var i = flatIndex(r, c);
    state.cells[i].textContent = num === 0 ? "" : num;
    refreshBoardHighlights();
    checkWin();
  }

  // ============================================
  // TIMER
  // ============================================
  function startTimer() {
    state.startTime = Date.now();
    state.timerId = setInterval(function () {
      var sec = Math.floor((Date.now() - state.startTime) / 1000);
      var m = Math.floor(sec / 60);
      var s = sec % 60;
      timerEl.textContent = m + ":" + (s < 10 ? "0" : "") + s;
    }, 1000);
  }

  function stopTimer() {
    if (state.timerId) clearInterval(state.timerId);
    state.timerId = null;
  }

  // ============================================
  // GAME FLOW
  // ============================================
  function startGame(level) {
    state.level = level;
    var config = LEVEL_CONFIG[level];
    state.size = config.size;
    state.boxRows = config.boxRows;
    state.boxCols = config.boxCols;
    state.checkBox = config.checkBox;
    var result = createPuzzle(level);
    state.solution = result.solution;
    state.puzzle = result.puzzle;
    state.given = result.given;
    state.selectedCell = null;
    stopTimer();
    timerEl.textContent = "0:00";
    levelBadge.textContent = LEVEL_LABELS[level];
    buildBoard();
    updateNumberPad();
    refreshBoardHighlights();
    startTimer();
  }

  function showGame() {
    levelScreen.classList.add("sudoku-hidden");
    gameScreen.classList.remove("sudoku-hidden");
  }

  function showLevelSelect() {
    stopTimer();
    gameScreen.classList.add("sudoku-hidden");
    levelScreen.classList.remove("sudoku-hidden");
  }

  // ============================================
  // EVENT LISTENERS
  // ============================================

  // Page-level: "Zagraj teraz" → show level select
  if (startBtn) {
    startBtn.addEventListener("click", function () {
      hideSection(introSection, function () {
        showSection(boardSection);
        showLevelSelect();
      });
    });
  }

  // Level buttons → start game
  document.querySelectorAll(".sudoku-level-btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      startGame(btn.dataset.level);
      showGame();
    });
  });

  // New game (same level)
  document.getElementById("sudokuNewGameBtn").addEventListener("click", function () {
    startGame(state.level);
  });

  // Change level
  document.getElementById("sudokuChangeLevelBtn").addEventListener("click", function () {
    showLevelSelect();
  });

  // Play again (from end screen)
  if (playAgainBtn) {
    playAgainBtn.addEventListener("click", function () {
      hideSection(endSection, function () {
        showSection(boardSection);
        showLevelSelect();
      });
    });
  }

  // Number pad
  numberPadEl.addEventListener("click", function (e) {
    var btn = e.target.closest(".sudoku-num-btn");
    if (!btn || !state.selectedCell) return;
    var num = parseInt(btn.dataset.num, 10);
    setCellValue(state.selectedCell.r, state.selectedCell.c, num);
  });

  // Keyboard input
  document.addEventListener("keydown", function (e) {
    if (!state.selectedCell) return;
    var r = state.selectedCell.r;
    var c = state.selectedCell.c;
    var maxNum = state.size;
    var n, next;
    if (e.key >= "1" && e.key <= "9") {
      n = parseInt(e.key, 10);
      if (n <= maxNum) setCellValue(r, c, n);
      e.preventDefault();
    } else if (e.key === "Backspace" || e.key === "Delete") {
      setCellValue(r, c, 0);
      e.preventDefault();
    } else if (e.key === "ArrowUp") {
      next = findNextSelectableCell(r, c, "up");
      if (next) selectCell(next.r, next.c);
      e.preventDefault();
    } else if (e.key === "ArrowDown") {
      next = findNextSelectableCell(r, c, "down");
      if (next) selectCell(next.r, next.c);
      e.preventDefault();
    } else if (e.key === "ArrowLeft") {
      next = findNextSelectableCell(r, c, "left");
      if (next) selectCell(next.r, next.c);
      e.preventDefault();
    } else if (e.key === "ArrowRight") {
      next = findNextSelectableCell(r, c, "right");
      if (next) selectCell(next.r, next.c);
      e.preventDefault();
    }
  });

  // ==================== DEV TOOLBAR ====================

  function createDevToolbar() {
    var toolbar = document.createElement('div');
    toolbar.style.cssText =
      'position:fixed;bottom:16px;right:16px;z-index:9999;display:flex;gap:6px;' +
      'background:rgba(0,0,0,0.85);padding:8px 12px;border-radius:8px;font-family:monospace;font-size:12px;';

    var screens = [
      { label: '① Intro', view: 'intro' },
      { label: '② Board', view: 'board' },
      { label: '③ End', view: 'end' }
    ];

    screens.forEach(function (s) {
      var btn = document.createElement('button');
      btn.textContent = s.label;
      btn.style.cssText =
        'background:#333;color:#fff;border:1px solid #555;padding:4px 10px;border-radius:4px;' +
        'cursor:pointer;font-family:inherit;font-size:12px;';
      btn.addEventListener('mouseenter', function () { btn.style.background = '#0077B6'; });
      btn.addEventListener('mouseleave', function () { btn.style.background = '#333'; });
      btn.addEventListener('click', function () {
        var targets = { intro: introSection, board: boardSection, end: endSection };
        var target = targets[s.view];
        var current = null;
        [introSection, boardSection, endSection].forEach(function (el) {
          if (el && el.classList.contains('sudoku-section--active')) current = el;
        });

        function afterSwitch() {
          showSection(target);
          if (s.view === 'board') showLevelSelect();
          if (s.view === 'end') {
            if (finalTimeEl) finalTimeEl.textContent = timerEl ? timerEl.textContent : '0:00';
            setTimeout(function () {
              if (typeof Modal !== 'undefined' && Modal.show) {
                Modal.show({
                  variant: 'points',
                  image: 'assets/images/own-it-card-big.jpg',
                  pointsNumber: '235',
                  pointsLabel: 'Punktów',
                  text: '<strong>Gratulacje!</strong><br/>Za udział w grze zdobywasz:',
                  value: '+ 10 PUNKTÓW',
                  textExtra: 'Wróć po kolejne w następnym miesiącu.',
                  confirmLabel: 'Zamknij'
                });
              }
            }, 3000);
          }
        }

        if (current && current !== target) {
          hideSection(current, afterSwitch);
        } else {
          afterSwitch();
        }
      });
      toolbar.appendChild(btn);
    });

    document.body.appendChild(toolbar);
  }

  // DEV toolbar — only on localhost
  if (window.location.hostname === 'localhost' || window.location.hostname === 'winston2dev.polymus.info.pl' || window.location.hostname === '127.0.0.1') {
    createDevToolbar();
  }
})();
